<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
          <v-card-title>
            Jobs
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              @input="getDataFromApi()"
              single-line
              hide-details
              clearable
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-autocomplete label="Organization" clearable v-model="organization_id_filter" :items="organizations" item-text="name" item-value="id" @change="getDataFromApi()">
            </v-autocomplete>
            <v-spacer></v-spacer>
            <v-btn
            class="mx-2"
            fab
            dark
            color="primary"
            @click="addNew"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="list"
            :options.sync="options"
            :items-per-page="itemsPerPage"
            :server-items-length="jobTotal"
            :loading="loading"
            class="elevation-1"
          >
          <template v-slot:item.is_featured="{ item }">
                <v-icon v-if="item.is_featured == 1" color="success">mdi-check</v-icon>
                <v-icon v-if="item.is_featured == 0" color="error">mdi-close-circle-outline</v-icon>
            </template> 
          <template v-slot:item.status="{ item }">
                <v-icon v-if="item.status == 1" color="success">mdi-check</v-icon>
                <v-icon v-if="item.status == 0" color="error">mdi-close-circle-outline</v-icon>
            </template> 
            
            <template v-slot:item.stop_publishing="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    :color="isWithinPublishingDates(item.start_publishing, item.stop_publishing) ? 'green' : 'red'"
                  >
                    {{ isWithinPublishingDates(item.start_publishing, item.stop_publishing) 
                      ? 'mdi-clock-check-outline' 
                      : 'mdi-clock-alert-outline' 
                    }}
                  </v-icon>
                </template>
                <span>
                  Start: {{ formatDate(item.start_publishing) }}<br>
                  Stop: {{ formatDate(item.stop_publishing) }}
                </span>
              </v-tooltip>
            </template>
            <template v-slot:item.type="{ item }">
              <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :color="item.status && isWithinPublishingDates(item.start_publishing, item.stop_publishing) ? 'green' : 'red'"
                >
                  {{ item.status && isWithinPublishingDates(item.start_publishing, item.stop_publishing) ? 'mdi-web' : 'mdi-web-off' }}
                </v-icon>
              </template>
              <span>
                {{ item.status && isWithinPublishingDates(item.start_publishing, item.stop_publishing) ? 'Active and within publishing dates' : 'Inactive or outside publishing dates' }}
              </span>
            </v-tooltip>
            </template>
            <template v-slot:item.job_link="{ item }">
                <a :href="item.job_link" target="_blank">Visit external link</a>
            </template>  
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="goToEdit(item.id)"
            >
              mdi-pencil
            </v-icon>
            <a 
                :href="'/job/'+item.alias" target="_blank">
              <v-icon
                small
                class="mr-2"
                
              >
                mdi-eye
              </v-icon>
            </a>
            
          </template>
        </v-data-table>
        </v-card> 

        <v-dialog v-model="dialogAdd"  fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialogAdd = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="dialogType == 'add'">Add New Job</v-toolbar-title>
          <v-toolbar-title v-if="dialogType == 'edit'">Edit {{newjob.name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                v-if="dialogType=='add'"
              dark
              text
              @click="saveAddDialog"
              :loading="loadingAdd"
            >
              Add
            </v-btn>
            <v-btn
                v-if="dialogType=='edit'"
              dark
              text
              @click="saveEditDialog"
            :loading="loadingAdd"
            >
              Update
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container v-if="errors">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-alert type="error">
                      <ul>
                        <li v-for="e in errors">
                          {{ e[0] }}
                        </li>
                      </ul>
                      
                    </v-alert>
                  </v-col>
                </v-row>
              </v-container>
        <v-container>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h4">Basic Information</p>
                  </v-col>
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-switch
                      v-model="newjob.status"
                      label="Active"
                    ></v-switch>
                </v-col>
                
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-switch
                    
                      v-model="newjob.is_featured"
                      label="Featured?"
                    ></v-switch>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                  <v-autocomplete
                      v-model="newjob.organization_id"
                      label="Organization"
                      :items="organizations"
                      item-text="name"
                      item-value="id"
                      clearable
                      required
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                  <v-autocomplete
                      v-model="newjob.category_id"
                      label="Category"
                      :items="categories"
                      item-text="title"
                      item-value="id"
                      clearable
                      required
                    ></v-autocomplete>
                  </v-col>
                  
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="newjob.title"
                      label="Title"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-text-field
                      v-model="newjob.alias"
                      label="Alias"
                      hint="No spaces or special characters, e.g. my-job"
                      required
                    ></v-text-field>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newjob.job_link"
                      required
                      label="Link to job"
                      prepend-icon="mdi-link"
                      placeholder="https://yourcompany.com/example_job or youremail@yourcompany.com"
                      hint="Add an email to receive emails with resumes"
                      persistent-hint
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-select
                      v-model="newjob.remote_type"
                      :items="['Remote','In-person','Hybrid']"
                      label="Remote Work?"
                      clearable
                    ></v-select>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-select
                      v-model="newjob.contract_type"
                      :items="contractItems"
                      label="Contract Type"
                      clearable
                    ></v-select>
                </v-col>
                </v-row>
                
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <p>Description*</p>
                    <vue-editor v-if="0" v-model="newjob.description" required style=""></vue-editor>
                    <ckeditor :editor="editor" v-model="newjob.description"></ckeditor>
                    <br/>
                    <br/>
                    <v-btn @click="newjob.description = ''">Clear</v-btn>
                    <v-btn @click="suggestImprovements" :loading="loadingSuggestions">Suggest Improvements</v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="improvedDescription">
                  <v-col cols="12" sm="12" md="12">
                    <p>Improved Description:</p>
                    <v-card>
                      <v-card-text v-html="improvedDescription"></v-card-text>
                    </v-card>
                    <v-btn @click="applyImprovedDescription" color="primary" class="mt-2">Apply Improved Description</v-btn>
                  </v-col>
                </v-row>
                
                <v-row v-if="0">
                  <v-col cols="12" sm="12">
                    <p class="text-h4">Optional Information</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <p>Skills</p>
                    <vue-editor v-model="newjob.skills" required style="max-height:500px;margin-bottom:50px"></vue-editor>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <p>Qualifications</p>
                    <vue-editor v-model="newjob.qualifications" required style="max-height:500px;margin-bottom:50px"></vue-editor>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Address</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-select
                      v-model="newjob.region"
                      label="Region"
                      :items="regions"
                      clearable
                    ></v-select>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newjob.address"
                      label="Street"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col> <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newjob.city"
                      label="City"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newjob.postal_code"
                      label="Postal Code"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Experience</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                    <v-select label="Minimum Experience (years)" :items="experienceItems" v-model="newjob.minimum_experience" clearable></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                    <v-select label="Maximum Experience (years)" :items="experienceItems" v-model="newjob.maximum_experience" clearable></v-select>

                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                    <v-select label="Job Level" :items="careerLevelItems" v-model="newjob.career_level" clearable></v-select>

                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Salary</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                    <v-text-field number minimum="0" label="Minimum Salary" v-model="newjob.minimum_salary" prefix="€"></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                  <v-text-field number minimum="0" label="Maximum Salary " v-model="newjob.maximum_salary" prefix="€"></v-text-field>

                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                    <v-select label="Salary Type" :items="salaryTypeItems" v-model="newjob.salary_type" clearable></v-select>

                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Publishing Dates</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >

                  <v-menu
                      ref="start_publishing_menu"
                      v-model="start_publishing_menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="newjob.start_publishing"
                          label="Start publishing on"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="newjob.start_publishing"
                        min="2023-01-01"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                  <v-menu
                      ref="stop_publishing_menu"
                      v-model="stop_publishing_menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="newjob.stop_publishing"
                          label="Stop publishing on"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="newjob.stop_publishing"
                        min="2023-01-01"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Tags</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field v-model="newtag" label="New Tag"></v-text-field>
                    <v-btn @click="addTag">Add</v-btn>
                    <v-btn @click="suggestTags">Suggest Tags</v-btn>
                  </v-col> 
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-select chips v-model="newjob.tags" :items="newjob.tags" label="Tags" multiple clearable></v-select>
                  </v-col> 
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12">
                    <p class="text-h5">Courses</p>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                  <v-autocomplete
                    v-model="newcourse"
                    :items="newcourseitems"
                    :search-input.sync="searchCourses"
                    color="white"
                    hide-no-data
                    hide-selected
                    label="Find a Course"
                    placeholder="Start typing to Search"
                    prepend-icon="mdi-database-search"
                    return-object
                  ></v-autocomplete>
                    <v-btn @click="addCourse">Add</v-btn>
                    <v-btn @click="suggestCourses">Suggest Courses</v-btn>
                  </v-col> 
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-select v-if="0" v-model="newjob.courses" :items="newjob.courses" label="Courses" multiple clearable></v-select>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Title</th>
                          <th>Organization</th>
                          <th>Status</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="c in newjob.courses" :key="c.value+'_rowkey'">
                          <td>{{ c.course.id }}</td>
                          <td>{{ c.course.title }}</td>
                          <td>{{ c.org.name }}</td>
                          <td>{{ c.course.status }}</td>
                          <td><v-icon @click="removeCourse(c)">mdi-delete</v-icon></td>
                        </tr>
                      </tbody>
                    </v-simple-table> 
                      
                  </v-col> 
                </v-row>
              </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddDialog"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="dialogType == 'add'"
                color="blue darken-1"
                text
                @click="saveAddDialog"
            :loading="loadingAdd"
              >
                Add New
              </v-btn>
              <v-btn
                v-if="dialogType == 'edit'"
                color="blue darken-1"
                text
                @click="saveEditDialog"
            :loading="loadingAdd"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" >
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete = !dialogDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import { Link } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  import { VueEditor } from "vue2-editor";
  import CKEditor from '@ckeditor/ckeditor5-vue2';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

  const passwordLength = 12
  const passwordChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

  export default {
    props: {
      jobs: Array,
      organizations:Array,
      categories:Array,
      regions:Array,
      total:Number,
    },
    components: {
      Head,
      VueEditor,
      Link,
      ckeditor: CKEditor.component
    },
    layout: Layout,
    data() {
        return {
            improvedDescription: null,
            loadingSuggestions: false,
            editor: ClassicEditor,
            pagination: {},
            start_publishing_menu:null,
            stop_publishing_menu:null,
            list: [],
            keyword: "",
            location: "",
            category: "",
            errors: false,
            itemsPerPage: 20,
            loading: false,
            loadingAdd: false,
            jobTotal: this.total + 0,
            options: {},
            search: "",
            organization_id_filter: null,
            headers: [
              { text: 'ID', value:'id'},
              { text: 'Title', value:'title'},
              { text: 'Featured', value:'is_featured'},
              { text: 'Dates', value:'stop_publishing'},
              { text: 'Manual Status', value:'status'},
              { text: 'Visible', value:'type'},
              { text: 'Organization', value:'organization.name'},
              { text: 'Link', value:'job_link'},
              { text: 'Actions', value:'actions'}

            ],
            experienceItems: [
              0,1,2,3,4,5,6,7,8,9,10
            ],
            careerLevelItems: [
              'Student (Undergrad)','Student (Graduate)','Entry level','Experienced','Manager','Executive','Senior Executive'
            ],
            salaryTypeItems: ['Hourly','Weekly','Monthly','Yearly'],
            contractItems: ['Full-time','Part-time','Contract','Returnships','Volunteer','Flexible'],
            newjob: {
              title:"",//
              organization_id: "",//
              category_id: "",//
              alias: "",//
              job_link:"",
              description: "",//
              status: false,
              is_featured:false,
              address: "",//
              city: "",//
              region: "",//
              country: "IE",//
              postal_code: "",//
              minimum_experience: '',
              maximum_experience: '',
              minimum_salary: '',
              maximum_salary: '',
              salary_type:'',
              career_level: '',
              start_publishing: '',
              stop_publishing: '',
              remote_type: '',
              tags:[],
              courses:[],
              contract_type:'',
            },
            newtag:"",
            dialogType:'add',
            dialogAdd: false,
            dialogDelete: false,
            newcourse: {},
            newcourseitems: [],
            searchCourses: null,

        }
    },
    watch: {
      options: {
        handler () {
          console.log('watching options',this.options)
          this.getDataFromApi()
        },
        deep: true,
      },
      searchCourses(i) {
        console.log('searchcourses',i)
        const formData = new FormData()
        formData.append('searchString',i);
        axios.post("/admin/courses/searchByTitle",formData).then((response) => {
            console.log('courses/searchByTitle got response',response.data)
            if (response && response.data)
            {
              console.log('got response',response.data) 
              this.newcourseitems = response.data
            }
        });
      },
    },
    created() {
      this.list = JSON.parse(JSON.stringify(this.jobs));

    },
    methods: {
      suggestImprovements() {
      this.loadingSuggestions = true;
      axios.post('/api/admin/improveDescription', {
        description: this.newjob.description
      })
        .then(response => {
          console.log('got results',response,response.data)
          this.improvedDescription = response.data.improvedDescription;
        })
        .catch(error => {
          console.error('Error suggesting improvements:', error);
          // You might want to show an error message to the user here
        })
        .finally(() => {
          this.loadingSuggestions = false;
        });
    },
    applyImprovedDescription() {
      this.newjob.description = this.improvedDescription;
      this.improvedDescription = null;
    },
      isWithinPublishingDates(startDate, stopDate) {
        const today = new Date();
        const start = new Date(startDate);
        const stop = new Date(stopDate);
        return today >= start && today <= stop;
      },
      formatDate(date) {
        if (!date) return 'N/A';
        return new Date(date).toLocaleDateString('en-IE', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        });
      },
      suggestCourses() {
        const formData = new FormData()
        Object.keys(this.newjob).forEach(key => formData.append(key, this.newjob[key]));


        axios.post("/admin/jobs/suggestCourses",formData).then((response) => {
            console.log('suggest courses got response',response.data)
            if (response && response.data)
            {
              let a = [...new Set([...this.newjob.courses, ...response.data])]  

              a = [...new Set(a.map(o => JSON.stringify(o)))].map(s => JSON.parse(s))
              this.newjob.courses = a;
              //this.newjob.courses = [...new Set([...this.newjob.courses, ...response.data])]  
            }
        });
      },
      removeCourse(c) {
        const objWithIdIndex = this.newjob.courses.findIndex((obj) => obj.value === c.value);

        if (objWithIdIndex > -1) {
          this.newjob.courses.splice(objWithIdIndex, 1);
        }
      },
      addCourse() {
        if (this.newcourse && !this.newjob.courses.includes(this.newcourse))
          this.newjob.courses.push(this.newcourse);
      },

      suggestTags() {
        const formData = new FormData()
        Object.keys(this.newjob).forEach(key => formData.append(key, this.newjob[key]));


        axios.post("/admin/jobs/suggestTags",formData).then((response) => {
            console.log('suggest tags got response',response.data)
            if (response && response.data)
            {
                this.newjob.tags = [...new Set([...this.newjob.tags, ...response.data])]  
            }
        });
      },
      addTag() {
        if (this.newtag)
          this.newjob.tags.push(this.newtag);
      },
      
      goToEdit(id) {
        this.$inertia.visit(`/admin/jobs/edit/${id}`);
      },
      edit(id) {
        this.errors=false;
        this.newtag = "";
        this.newjob.courses = [];
        console.log('attempting to edit id ',id)
        axios.get("/admin/jobs/get/"+id).then((response) => {
            console.log('edit got response',response.data)
            if (response && response.data)
            {
                this.newjob = response.data
                this.newjob.description = this.newjob.description ? this.newjob.description.replace("/>\s+</","><") : "";
                if (this.newjob.status)
                  this.newjob.status = true;
                if (this.newjob.is_featured)
                  this.newjob.is_featured = true;
                if (this.newjob.tag_strings && this.newjob.tag_strings.length)
                {
                  this.newjob.tags = this.newjob.tag_strings
                }
                if (!this.newjob.courses)
                  this.newjob.courses = [];
                if (this.newjob.courseList && this.newjob.courseList.length)
                {
                  this.newjob.courses = this.newjob.courseList
                }
                this.dialogAdd = true;
                this.dialogType='edit';
            }
        });
      },
      addNew(){
        this.newtag = "";
        this.newcourse = "";
        this.newjob.courses = [];
        this.dialogType='add';
        Object.keys(this.newjob).forEach(key => {
            if (key == 'photo')
                this.newjob.key = []
            else
                this.newjob[key] = "";
        });
        this.dialogAdd = true;
      },
      getDataFromApi () {
        this.loading = true
        console.log('getting request',this.options)
        var params = JSON.parse(JSON.stringify(this.options));
        params.filters = { search: this.search, role: this.role, organization_id:this.organization_id_filter };

        axios.get("/admin/jobs/list",{ params: params }).then((response) => {
          this.list = response.data.list
          this.total= response.data.total;
          this.loading = false;
        });
      },
      deleteItemConfirm () {
        this.closeDelete()
      },

      closeAddDialog () {
        this.dialogAdd = false
      },

      closeDelete () {
        this.dialogDelete = false
        
      },
      saveEditDialog () {
        this.errors=false;
        this.loadingAdd=true;
        const formData = new FormData()
        Object.keys(this.newjob).forEach(key => formData.append(key, this.newjob[key]));
        let cs = JSON.parse(JSON.stringify(this.newjob.courses));
        if (this.newjob.courses && this.newjob.courses.length)
          formData.set('courses',cs.map(a => a.value).join());
        axios.post("/admin/jobs/update",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Edit failed');
          
            console.log('edit response',response)
            this.loadingAdd = false;
        }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      saveAddDialog () {
        this.loadingAdd=true;
        this.errors=false;
        console.log('adding job',this.newjob)
        const formData = new FormData()
        Object.keys(this.newjob).forEach(key => formData.append(key, this.newjob[key]));
        if (this.newjob.courses && this.newjob.courses.length)
          formData.set('courses',this.newjob.courses.map(a => a.value).join());
        axios.post("/admin/jobs/add",formData).then((response) => {
          if (response.status == '200' && response.data.success == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
            this.goToEdit(response.data.id);
          }
          else
            alert('Add failed: ');
          
            console.log('add response',response)
          this.loadingAdd = false;
        }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      
    },
  }
  </script>
  